import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
  Switch,
  Popover,
} from "@mui/material";
import {
  DonutLarge as DashboardIcon,
  PersonAddAlt1 as AssignIcon,
  PersonRemove as UnassignIcon,
  FormatListBulleted as ListIcon,
  Sync as RecallIcon,
  ManageSearch as RecalledIcon,
  ViewColumn as ColumnsIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AssignEpisodesDialog from "./AssignEpisodesDialog";
import { useDispatch, useSelector } from "react-redux";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  assignEpisodes,
  getCodeEnhanceWorkflowViewData,
  unassignEpisode,
  getUnassignedEpisodes,
  recallEpisodes,
  getRecalledEpisodes,
  reflagEpisodes,
  combinedReviewUnassignEpisode,
  reflagCombinedReviewEpisodes,
  setPayload,
} from "../pages/EnhanceWorkflow/EnhanceWorkflowSlice";
import {
  getCombinedReviewData,
  setCombinedPayload,
} from "../pages/combinedReview/CombinedReviewSlice";
import { toast } from "react-toastify";
import UnassignReasonModal from "../pages/UnassignModal/UnassignReasonModal";
import AssignReasonModal from "../pages/AssignReasonModal/AssignReasonModal";
import { getEnhancePlusWorkflowData, getEnhancePlusWorkUnassignedEpisode, recallEnhancePlusEpisodes, reflagEnhancePlusEpisodes, updatedEnhancePlusPayload } from "../pages/EnhancePlusWorkflow/EnhancePlusWorkflowSlice";
const ICON_COLOR = "#42526E";
const TEXT_COLOR = "#172B4D";
const SIDEBAR_WIDTH = 230;

const WorkflowSidebar = ({
  selected,
  onSelect,
  activeModule,
  onModuleChange,
  selectedRows = [],
  isSelectAll = false,
  onAssignComplete,
  isRecalledView,
  setIsRecalledView,
  isUnassignedView,
  setIsUnassignedView,
  setSidebarSelected,
  sidebarSelected,
  preferredColumnGroups = [],
  onTogglePreferredColumnGroup,
  onTogglePreferredColumn,
}) => {
  console.log(activeModule ,"activeModule")
  const navigate = useNavigate();
  const [openAssign, setOpenAssign] = useState(false);
  const [assignAnchorEl, setAssignAnchorEl] = useState(null);
  const selectedRecall = selected === "Recall";
  const dispatch = useDispatch();
  const enhancePayload = useSelector((state) => state.codeEnhance.payload);
  const [unassignOpen, setUnassignOpen] = useState(false);
  const [unassigning, setUnassigning] = useState(false);
  const [assignReasonOpen, setAssignReasonOpen] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [pendingAssign, setPendingAssign] = useState(null);
  const combinedPayload = useSelector((state) => state.combinedReview.payload);
  const enhancePlusPayload = useSelector(
      (state) => state.enhancePlusWorkflow.payload,
    );
    console.log(enhancePlusPayload)
  const currentUserId = sessionStorage.getItem("userId");

  // NEW — below the "md" breakpoint the sidebar collapses behind a hamburger
  // icon and opens as an overlay Drawer instead of taking up permanent width.
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [preferredColumnsAnchor, setPreferredColumnsAnchor] = useState(null);

  const itemSx = {
    py: 0.7,
    mx: 1.25,
    mb: 0.25,
    // borderBottom: "1px solid #E2E8F0",

    "&:hover": {
      bgcolor: "#55B4B01A",
      "& .MuiListItemText-primary": {
        color: "#55B4B0 !important",
      },
      "& .MuiListItemIcon-root": {
        color: "#55B4B0 !important",
      },
      "& .MuiSvgIcon-root": {
        color: "#55B4B0 !important",
      },
      borderLeft: "3px solid #55B4B0",
    },

    "&.Mui-selected": {
      bgcolor: "#55B4B01A",
      borderLeft: "3px solid #55B4B0",
      borderRadius: "8px",
      pl: "13px",
      "& .MuiListItemText-primary": {
        color: "#55B4B0 !important",
      },
      "& .MuiListItemIcon-root": {
        color: "#55B4B0 !important",
      },
      "& .MuiSvgIcon-root": {
        color: "#55B4B0 !important",
      },
    },
  };

  // NEW — wrap onSelect/actions so the drawer auto-closes on mobile after a
  // choice is made, without touching any of the underlying handler logic.
  const closeMobileDrawer = () => {
    if (!isDesktop) setMobileOpen(false);
  };

  const handleAssignClick = (e) => {
    if (selectedRows.length === 0) {
      alert("Please select episode(s)");
      return;
    }

    setAssignAnchorEl(e.currentTarget);
    setOpenAssign(true);
    closeMobileDrawer();
  };
  const handleAssign = ({ coder, episodes }) => {
    if (!coder) return;
    if (!episodes.length) {
      alert("Please select episode(s)");
      return;
    }
    setPendingAssign({ coder, episodes });
    setOpenAssign(false);
    setAssignReasonOpen(true);
  };

  const handleConfirmAssignReason = async (reason) => {
    if (!pendingAssign) return;
    const { coder, episodes } = pendingAssign;

    const currentPayload =
      activeModule === "Combined Review" ? combinedPayload : activeModule === "Enhance Plus Workflow" ?enhancePlusPayload:enhancePayload;

    setAssigning(true);
    try {
      await dispatch(
        assignEpisodes({
          assigned_user_id: coder.user_id,
          assignment_reason: reason,
          assigned_by: Number(currentUserId),
          assignment: true,
          is_flagged: false,
          hcp_lines: episodes.map((item) => item.hcpLineId),
          filter: currentPayload,
        }),
      ).unwrap();

      setAssignReasonOpen(false);
      setPendingAssign(null);

      if (activeModule === "Combined Review") {
        dispatch(
          getCombinedReviewData({
            ...currentPayload,
            unassigned_page: false,
            is_flagged: false,
            recall: false,
            page_number: 1,
          }),
        ).unwrap();
      }else if (activeModule === "Enhance Plus Workflow"){
        dispatch(
    getEnhancePlusWorkflowData({
      ...currentPayload,
      unassigned_page: false,
      is_flagged: false,
      recall: false,
      page_number: 1,
    }),
  ).unwrap();  
      }
      else {
        dispatch(
          getCodeEnhanceWorkflowViewData({
            ...currentPayload,
            unassigned_page: false,
            is_flagged: false,
            recall: false,
            page_number: 1,
          }),
        ).unwrap();
      }
      setIsUnassignedView(false);
      setIsRecalledView(false);
      setSidebarSelected("");
      onSelect?.("");
      onAssignComplete?.();
      toast.success("Episode assigned successfully");
    } catch (err) {
      console.log(err);
      toast.error("Failed to assign episode");
    } finally {
      setAssigning(false);
    }
  };

  const handleOpenUnassign = () => {
    if (selectedRows.length === 0) {
      alert("Please select episode(s)");
      return;
    }
    setUnassignOpen(true);
    closeMobileDrawer();
  };

  const handleConfirmUnassign = async (reason) => {
    const currentPayload =
      activeModule === "Combined Review" ? combinedPayload : activeModule === "Enhance Plus Workflow" ?enhancePlusPayload:enhancePayload;

    setUnassigning(true);
    try {
      const unassignPayload = {
        hcp_lines: selectedRows.map((item) => item.hcpLineId),
        unassigned_by: Number(currentUserId),
        unassignment_reason: reason,
        select_all: false,
        user_id: Number(currentUserId),
        filter: currentPayload,
      };

      if (activeModule === "Combined Review") {
        await dispatch(combinedReviewUnassignEpisode(unassignPayload)).unwrap();
        await dispatch(getCombinedReviewData(currentPayload)).unwrap();
      }else if(activeModule === "Enhance Plus Workflow"){
        await dispatch(getEnhancePlusWorkUnassignedEpisode(unassignPayload)).unwrap()
        await dispatch(getEnhancePlusWorkflowData(currentPayload)).unwrap()
      } else {
        await dispatch(unassignEpisode(unassignPayload)).unwrap();
        await dispatch(getCodeEnhanceWorkflowViewData(currentPayload)).unwrap();
      }

      toast.success("Episode unassigned successfully");
      setUnassignOpen(false);
      onAssignComplete?.();
    } catch (err) {
      console.log(err);
      toast.error("Failed to unassign episode");
      // keep modal open so the user can retry/edit reason
    } finally {
      setUnassigning(false);
    }
  };

  const handleUnassignedEpisodes = async () => {
    try {
      if (activeModule === "Combined Review") {
        const updated = {
          ...combinedPayload,
          unassigned_page: true,
          is_flagged: false,
          recall: false,
          page_number: 1,
        };
        dispatch(setCombinedPayload(updated));
        // await dispatch(getCombinedReviewData(updated));
      }else if(activeModule === "Enhance Plus Workflow"){
           const updated = {
          ...enhancePlusPayload,
          unassigned_page: true,
          is_flagged: false,
          recall: false,
          page_number: 1,
        };
        dispatch(updatedEnhancePlusPayload(updated));
      } else {
        const updated = {
          ...enhancePayload,
          unassigned_page: true,
          is_flagged: false,
          recall: false,
          page_number: 1,
        };
        dispatch(setPayload(updated));
        // await dispatch(getCodeEnhanceWorkflowViewData(updated));
      }
      setIsUnassignedView(true);
      setIsRecalledView(false);
      onSelect?.("Unassigned Episodes");
      closeMobileDrawer();
    } catch (err) {
      console.log(err);
    }
  };

  const handleRecall = async () => {
    if (isUnassignedView) {
      toast.error("Unassigned episodes cannot be recalled.");
      return;
    }
    if (selectedRows.length === 0) {
      alert("Please select episode(s)");
      return;
    }

    const currentPayload =
     activeModule === "Combined Review" ? combinedPayload : activeModule === "Enhance Plus Workflow" ?enhancePlusPayload:enhancePayload;

    const recallPayload = {
      hcp_lines: selectedRows.map((item) => item.hcpLineId),
      // hcp_lines: isSelectAll
      // ? []
      // : selectedRows.map((item) => item.hcpLineId),
      select_all: false,
      filter: {
        ...currentPayload,
        page_number: 1,
        is_flagged: false,
      },
      flag_episode_to: true,
    };

    try {
      if (activeModule === "Combined Review") {
        await dispatch(reflagCombinedReviewEpisodes(recallPayload)).unwrap();
        await dispatch(getCombinedReviewData(currentPayload)).unwrap();
      }else if(activeModule === "Enhance Plus Workflow"){
        await dispatch(recallEnhancePlusEpisodes(recallPayload)).unwrap();
        await dispatch(getEnhancePlusWorkflowData(currentPayload)).unwrap();
      } else {
        await dispatch(recallEpisodes(recallPayload)).unwrap();
        await dispatch(getCodeEnhanceWorkflowViewData(currentPayload)).unwrap();
      }

      setIsRecalledView(false);
      setSidebarSelected("");
      onSelect?.("");
      onAssignComplete?.();

      toast.success("Recall successfully");
      closeMobileDrawer();
    } catch (err) {
      console.error(err);
    }
  };

  const handleRecalledEpisodes = async () => {
    try {
      if (activeModule === "Combined Review") {
        const updated = {
          ...combinedPayload,
          is_flagged: true,
          page_number: 1,
          unassigned_page: false,
          recall: true,
        };
        dispatch(setCombinedPayload(updated));
        // await dispatch(getCombinedReviewData(updated));
      }else if (activeModule === "Enhance Plus Workflow") {
  const updated = {
    ...enhancePlusPayload,
    is_flagged: true,
    recall: true,
    unassigned_page: false,
    page_number: 1,
  };

  dispatch(updatedEnhancePlusPayload(updated));
} else {
        const updated = {
          ...enhancePayload,
          is_flagged: true,
          page_number: 1,
          unassigned_page: false,
          recall: true,
        };
        dispatch(setPayload(updated));
        // await dispatch(getCodeEnhanceWorkflowViewData(updated)).unwrap();
      }

      setIsRecalledView(true);
      setIsUnassignedView(false);
      onSelect?.("Recalled Episodes");
      onAssignComplete?.();
      closeMobileDrawer();
    } catch (err) {
      console.log(err);
    }
  };
  const handleReflag = async () => {
    if (selectedRows.length === 0) {
      alert("Please select episode(s)");
      return;
    }

    const currentPayload =
      activeModule === "Combined Review" ? combinedPayload : activeModule === "Enhance Plus Workflow" ?enhancePlusPayload:enhancePayload;

    const payloadData = {
      hcp_lines: selectedRows.map((item) => item.hcpLineId),
      // hcp_lines: isSelectAll
      // ? []
      // : selectedRows.map((item) => item.hcpLineId),
      select_all: false,
      filter: {
        ...currentPayload,
        page_number: 1,
        is_flagged: true,
      },
      flag_episode_to: false,
    };

    try {
      if (activeModule === "Combined Review") {
        await dispatch(reflagCombinedReviewEpisodes(payloadData)).unwrap();
        await dispatch(
          getCombinedReviewData({
            ...currentPayload,
            is_flagged: false,
            page_number: 1,
            recall: false,
          }),
        ).unwrap();
      }else if (activeModule === "Enhance Plus Workflow") {
    await dispatch(reflagEnhancePlusEpisodes(payloadData)).unwrap();

    await dispatch(
        getEnhancePlusWorkflowData({
            ...currentPayload,
            is_flagged: false,
            recall: false,
            page_number: 1,
        })
    ).unwrap();
} else {
        await dispatch(reflagEpisodes(payloadData)).unwrap();
        await dispatch(
          getCodeEnhanceWorkflowViewData({
            ...currentPayload,
            is_flagged: false,
            page_number: 1,
            recall: false,
          }),
        ).unwrap();
      }

      setIsRecalledView(false);
      setSidebarSelected("");
      onSelect?.("");
      onAssignComplete?.();

      toast.success("Reflag successfully");
      closeMobileDrawer();
    } catch (err) {
      console.error(err);
    }
  };

  const handleAuditRuleSettings = () => {
    navigate("/powerapp");
    closeMobileDrawer();
  };

  // NEW — the actual list of workflow actions, extracted so it can be
  // rendered either inline (desktop, permanent) or inside a Drawer (mobile/tablet).
  const sidebarBody = (
    <>
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #E2E8F0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="subtitle2"
          fontWeight={700}
          color="#8A94A6"
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            fontSize: "0.72rem",
          }}
        >
          Workflow Actions
        </Typography>
        {!isDesktop && (
          <IconButton size="small" onClick={() => setMobileOpen(false)} sx={{ p: 0.5 }}>
            <CloseIcon fontSize="small" sx={{ color: ICON_COLOR }} />
          </IconButton>
        )}
      </Box>

      <List sx={{ py: 0.5 }}>
        <ListItem disablePadding>
          <ListItemButton
            // sx={itemSx}
            sx={{ ...itemSx, borderBottom: "1px solid #E2E8F0" }}
            selected={selected === "Dashboard"}
            onClick={() => {
              onSelect?.("Dashboard");
              closeMobileDrawer();
            }}
          >
            <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
              <DashboardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              onClick={() => {
                navigate("/workflow-dashboard");
                closeMobileDrawer();
              }}
              primary="Dashboard"
              primaryTypographyProps={{ fontSize: "0.8rem", color: TEXT_COLOR }}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton sx={itemSx} onClick={handleAssignClick}>
            <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
              <AssignIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Assign"
              primaryTypographyProps={{ fontSize: "0.8rem", color: TEXT_COLOR }}
            />
            {openAssign ? (
              <ExpandLessIcon fontSize="small" sx={{ color: ICON_COLOR }} />
            ) : (
              <ExpandMoreIcon fontSize="small" sx={{ color: ICON_COLOR }} />
            )}
          </ListItemButton>
        </ListItem>

        {!isUnassignedView && (
          <List component="div" disablePadding>
            <ListItemButton
              sx={itemSx}
              selected={selected === "Unassign"}
              onClick={handleOpenUnassign}
            >
              <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
                <UnassignIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Unassign"
                primaryTypographyProps={{
                  fontSize: "0.8rem",
                  color: TEXT_COLOR,
                }}
              />
            </ListItemButton>
          </List>
        )}

        <ListItem disablePadding>
          <ListItemButton
            // sx={itemSx}
            sx={{ ...itemSx, borderBottom: "1px solid #E2E8F0" }}
            selected={selected === "Unassigned Episodes"}
            onClick={handleUnassignedEpisodes}
          >
            <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
              <ListIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Unassigned Episodes"
              primaryTypographyProps={{ fontSize: "0.8rem", color: TEXT_COLOR }}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={itemSx}
            selected={selected === "Recall" || selected === "Recalled Episodes"}
            // onClick={handleRecall}
            onClick={isRecalledView ? handleReflag : handleRecall}
          >
            <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
              <RecallIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={isRecalledView ? "Return Episode to Audit" : "Exclude Episode from Audit "}
              primaryTypographyProps={{ fontSize: "0.8rem", color: TEXT_COLOR }}
            />
          </ListItemButton>
        </ListItem>

        {!isRecalledView && (
          <ListItem disablePadding>
            <ListItemButton
              // sx={itemSx}
              sx={{ ...itemSx, borderBottom: "1px solid #E2E8F0" }}
              selected={selected === "Recalled Episodes"}
              onClick={handleRecalledEpisodes}
            >
              <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
                <RecalledIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Return Episode to Audit"
                primaryTypographyProps={{
                  fontSize: "0.8rem",
                  color: TEXT_COLOR,
                }}
              />
            </ListItemButton>
          </ListItem>
        )}

        <ListItem disablePadding>
          <ListItemButton
            sx={itemSx}
            selected={selected === "Audit Rule Settings"}
            onClick={handleAuditRuleSettings}
          >
            <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Audit Rule Settings"
              primaryTypographyProps={{ fontSize: "0.8rem", color: TEXT_COLOR }}
            />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            sx={itemSx}
            selected={Boolean(preferredColumnsAnchor)}
            onClick={(event) => setPreferredColumnsAnchor((anchor) => anchor ? null : event.currentTarget)}
            aria-expanded={Boolean(preferredColumnsAnchor)}
          >
            <ListItemIcon sx={{ minWidth: 32, color: ICON_COLOR }}>
              <ColumnsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Show Preferred Columns"
              primaryTypographyProps={{ fontSize: "0.8rem", color: TEXT_COLOR }}
            />
            {preferredColumnsAnchor ? <ExpandLessIcon fontSize="small" sx={{ color: ICON_COLOR }} /> : <ExpandMoreIcon fontSize="small" sx={{ color: ICON_COLOR }} />}
          </ListItemButton>
        </ListItem>
        <Popover
          open={Boolean(preferredColumnsAnchor)}
          anchorEl={preferredColumnsAnchor}
          onClose={() => setPreferredColumnsAnchor(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          slotProps={{ paper: { sx: { width: 320, maxWidth: "calc(100vw - 32px)", maxHeight: 420, overflow: "hidden", border: "1px solid #E2E8F0", boxShadow: "0 8px 24px rgba(15, 23, 42, 0.14)" } } }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", maxHeight: 420 }}>
            <Typography sx={{ px: 2, py: 1.25, fontSize: "0.8rem", fontWeight: 700, color: TEXT_COLOR, borderBottom: "1px solid #E2E8F0" }}>
              Preferred Columns
            </Typography>
            <List component="div" disablePadding sx={{ overflowY: "auto", minHeight: 0, py: 0.5 }}>
            {preferredColumnGroups.map((group) => (
              <React.Fragment key={group.name}>
                <ListItemButton
                  sx={{ ...itemSx, py: 0.35 }}
                  onClick={() => onTogglePreferredColumnGroup?.(group.name)}
                >
                  <ListItemText
                    primary={group.name}
                    primaryTypographyProps={{ fontSize: "0.75rem", color: TEXT_COLOR, fontWeight: 700 }}
                  />
                  <Switch
                    size="small"
                    checked={group.visible}
                    onClick={(event) => event.stopPropagation()}
                    onChange={() => onTogglePreferredColumnGroup?.(group.name)}
                    inputProps={{ "aria-label": `Show ${group.name} columns` }}
                  />
                </ListItemButton>
                {group.children?.map((column) => (
                  <ListItemButton
                    key={column.field}
                    sx={{ ...itemSx, py: 0.2, pl: 4 }}
                    onClick={() => onTogglePreferredColumn?.(column.field)}
                  >
                    <ListItemText
                      primary={column.headerName}
                      primaryTypographyProps={{ fontSize: "0.7rem", color: TEXT_COLOR }}
                    />
                    <Switch
                      size="small"
                      checked={column.visible}
                      onClick={(event) => event.stopPropagation()}
                      onChange={() => onTogglePreferredColumn?.(column.field)}
                      inputProps={{ "aria-label": `Show ${column.headerName} column` }}
                    />
                  </ListItemButton>
                ))}
              </React.Fragment>
            ))}
            </List>
          </Box>
        </Popover>
      </List>
    </>
  );

  return (
    <>
      {/* NEW — hamburger trigger, only rendered below the "md" breakpoint.
          The outer Box is 0x0 so it takes NO space in the parent flex row
          (no more stretched sidebar-width/full-height column). The inner
          Box is absolutely positioned off that zero-size anchor, so it
          renders pinned to the top-left corner instead of being vertically
          centered in what used to be the sidebar's column. */}
      {!isDesktop && (
        <Box sx={{ position: "relative", width: 0, height: 0, overflow: "visible" }}>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              bgcolor: "#F1F5F9",
              border: "1px solid #E2E8F0",
              borderRadius: 1,
              px: 1,
              py: 0.5,
              zIndex: 5,
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            <IconButton onClick={() => setMobileOpen(true)} size="small" sx={{ p: 0.75 }}>
              <MenuIcon fontSize="small" sx={{ color: ICON_COLOR }} />
            </IconButton>
            <Typography
              sx={{
                ml: 1,
                fontWeight: 700,
                fontSize: "0.8rem",
                color: "#8A94A6",
                textTransform: "uppercase",
                letterSpacing: "0.6px",
              }}
            >
              Workflow Actions
            </Typography>
          </Box>
        </Box>
      )}

      {isDesktop ? (
        <Box
          sx={{
            width: SIDEBAR_WIDTH,
            height: "91.5vh",
            bgcolor: "#F1F5F9",
            overflowY: "auto",
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            // borderRadius:"10px",
            borderTopRightRadius: "10px",
          }}
        >
          {sidebarBody}
        </Box>
      ) : (
        <Drawer
          anchor="left"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: { xs: "78vw", sm: SIDEBAR_WIDTH },
              maxWidth: SIDEBAR_WIDTH,
              bgcolor: "#F1F5F9",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          {sidebarBody}
        </Drawer>
      )}

      <AssignEpisodesDialog
        open={openAssign}
        anchorEl={assignAnchorEl}
        onClose={() => setOpenAssign(false)}
        selectedEpisodes={selectedRows}
        onAssign={handleAssign}
      />
      <UnassignReasonModal
        isOpen={unassignOpen}
        onClose={() => setUnassignOpen(false)}
        onConfirm={handleConfirmUnassign}
        loading={unassigning}
      />
      <AssignReasonModal
        isOpen={assignReasonOpen}
        onClose={() => {
          setAssignReasonOpen(false);
          setPendingAssign(null);
        }}
        onConfirm={handleConfirmAssignReason}
        loading={assigning}
      />
    </>
  );
};

export default WorkflowSidebar;
